export const getAdminServer = () => {
  let host = window.location.host;
  if (host.startsWith("localhost")) {
    return "http://localhost:8080";
  } else if (host.endsWith("thymebook.com")) {
    return 'https://admin-1096702705153.us-central1.run.app';
  } else if (host.endsWith("onkensu.com") || host.endsWith("kensu-admin-fj315.web.app")) {
    return 'https://admin-1086228175501.us-central1.run.app';
  }

  throw new Error("Unknown host");
}


export const getBookingHost = () => {
  if (window.location.host.startsWith("localhost")) {
    return "http://localhost:3001";
  } else if (window.location.host.endsWith("thymebook.com")) {
    return "https://thymebook.com";
  }

  return "https://onkensu.com";
}